import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_ITEMS, BOTTOM_NAV_ROUTES } from './MobileBottomNav';

// Navegação principal do cliente no desktop (sidebar fixa). Só ≥ md, e apenas nas 4 áreas.
export const ClientDesktopNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (!BOTTOM_NAV_ROUTES.includes(location.pathname)) return null;

  return (
    <aside
      className="hidden md:flex fixed top-0 left-0 z-40 h-screen w-60 flex-col border-r border-slate-200 bg-white"
      data-testid="client-desktop-nav"
    >
      <div className="flex items-center gap-2 px-6 h-16 border-b border-slate-100">
        <span className="text-xl font-bold tracking-tight text-primary">JATOO</span>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV_ITEMS.map(({ slug, label, icon: Icon, to }) => {
          const active = location.pathname === to;
          return (
            <button
              key={to}
              type="button"
              onClick={() => navigate(to)}
              aria-current={active ? 'page' : undefined}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                active ? 'bg-primary/10 text-primary font-semibold' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
              }`}
              data-testid={`desktopnav-${slug}`}
            >
              <Icon className="w-5 h-5 shrink-0" strokeWidth={active ? 2.4 : 2} />
              <span>{label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default ClientDesktopNav;
